module.exports = __webpack_public_path__ + "static/media/sudoku.80a74cd8.gif";